import {PlayerAPI} from 'bitmovin-player';
import {createContext, useContext} from 'react';

interface PlayerContextValue {
  accentColor: string;
  player: PlayerAPI | null;
}

export const PlayerContext = createContext<PlayerContextValue>({
  accentColor: '#FFFFFF',
  player: null,
});

export const usePlayerContext = (): PlayerContextValue =>
  useContext(PlayerContext);
